import React, { useState, useEffect, useContext } from "react";
import "../Product_Cart.css";
import "../Shop_Now/Shop_Now.css";
import {
  Breadcrumb,
  Button,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import classNames from "classnames";
import CoupanModal from "../../Common_modal/coupon_modal/couponModal";
import CouponModal from "../../Common_modal/CouponModal/CouponModal";

import { Context } from "../../../utils/context";
import ProgressBar from "react-bootstrap/ProgressBar";

import {
  CartQuantity,
  deleteCart,
  getCart,
} from "../../../utils/apis/addToCart/addToCart";

import { getCouponCode } from "../../../utils/apis/orderProcess/orderProcess";
import { Errors } from "../../../utils/errors";
import { useLocation } from "react-use";
import { getAppSetup } from "../../../utils/apis/common/Common";
import axios from "axios";
import {
  UserGet,
  UserGetInvestCount,
} from "../../../utils/apis/myAccount/myAccount";
import { logDOM } from "@testing-library/react";

const Cart = ({
  type,
  amount,
  setAmount,
  coupon,
  setCoupon,
  setTotalTax,
  tax,
  setDeliveryInstruction,
  setAdminAmount,
  adminAmount,
}) => {
  const navigate = useNavigate();
  const {
    IMG_URL,
    signin,
    triggerCartUpdate,
    setopen_delivery,
    open_delivery,
    setquick_delivery,
    quick_delivery,
    appSetup,
    setAppSetup,
    setSellerPincode,
    sellerPincode,
    deliveryPincode,
    outOfStock,
    userdata,
    setUserData,
    membershipDiscount,
    setMembershipDiscount,
    setDiscount,
    discount,
    setDeliveryCharges,
  } = useContext(Context);

  const [investCount, setInvestCount] = useState("");
  const [couponErrors, setCouponError] = useState("");

  const getUser = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUserData(res.data);
    }
  };

  const getUserinvestCount = async () => {
    const res = await UserGetInvestCount();
    if (res?.success) {
      setInvestCount(res.data);
    }
  };

  useEffect(() => {
    getUser();
    getUserinvestCount();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const appSetupGet = async () => {
    const res = await getAppSetup();
    if (res?.success) {
      setAppSetup(res?.data);
    }
  };

  useEffect(() => {
    appSetupGet();
  }, []);

  const location = useLocation();
  const showButton = location.pathname !== "/product-cart-details";

  var [message, setMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowCoupon, setModalShowCoupon] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [couponStatus, setCouponStatus] = useState(false);

  const [copyCode, setCopyCode] = useState("");
  const [cardError, setCardError] = useState();
  let totalPrice = 0;

  let totalAmount = 0;

  let baseAmount = 0;

  let taxPercent = 0;

  let totalTax = 0;

  let shippingCharges = 0;

  let extraDiscount = 0;

  let discountRate = 0;

  let membershipDiscountAmount = 0;

  let boomerbuckzProfitAmount = 0;

  let totalWithTax = totalPrice;

  const handleDeleteRecord = async (id) => {
    const response = await deleteCart(id);
    if (response?.success) {
      setModalShow(true);

      setTimeout(() => {
        cartGet();
        setModalShow(false);
      }, 2000);
    } else {
      console.error("Failed to delete the record");
    }
  };
  const [cart, setCart] = useState([]);

  const product_id = cart?.map((value) => value?.product_id);
  const varient_amount = cart?.map(
    (value) =>
      value?.product_variant?.s_price * value.quantity ||
      value?.product_multiple_variant?.s_price * value.quantity,
  );

  const onSubmit = async (data) => {
    setError("code", "");
    const res = await getCouponCode(data?.code, varient_amount, product_id);
    if (res?.success) {
      if (res?.couponCode) {
        setModalShowCoupon(true);
        setCoupon(res?.couponCode?.id);
        setCouponStatus(true);
        if (res?.couponCode?.type === "fixedamount") {
          setDiscount(res?.couponCode?.total_amount);
          setMessage(`Coupon Applied of Rs. ${res?.couponCode?.total_amount}`);
        } else {
          const discountPercentage = Number(res?.couponCode?.discount) || 0;
          const price = Number(totalPrice) + Number(shippingCharges) || 0;
          const discountAmount = price * (discountPercentage / 100);
          setDiscount(discountAmount);
          setMessage(`${discountPercentage} % Discount Applied`);
          setCardError("");
        }
        setTimeout(() => {
          setModalShowCoupon(false);
          setMessage("");
          setCardError("");
        }, 3000);
      }
      setCouponError("");
    } else {
      setCouponError(res?.message);
      setDiscount(0);
      setCoupon("");
      setCouponStatus(false);
      setError("code", { message: "Coupon Invalid" });
      setCardError("");
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////

  let productmembership = cart?.map((value) => value?.product?.membership_type);

  useEffect(() => {
    if (cart.length > 0) {
      setSellerPincode(cart[0].product?.user?.store_detail?.pincode?.name);
    }
  }, [cart]);

  const getCartQuantity = async (id, type) => {
    setDiscount(0);
    setCoupon();
    setCouponStatus(false);
    setError("code", "");

    await CartQuantity(id, type);
    if (Cookies.get("boomer_bucks_cart")) {
      if (JSON.parse(Cookies.get("boomer_bucks_cart")).length === 0) {
        navigate("/product-cart");
      }
      setCart(JSON.parse(Cookies.get("boomer_bucks_cart")));
      withoutCart();
    }
    if (signin) {
      await cartGet();
    }
    triggerCartUpdate();
  };

  const cartGet = async () => {
    const res = await getCart();
    if (res?.success) {
      if (res?.data.length === 0) {
        navigate("/product-cart");
      }
      setCart(res?.data);
    }
  };

  const withoutCart = async () => {
    if (Cookies.get("boomer_bucks_cart")) {
      if (JSON.parse(Cookies.get("boomer_bucks_cart")).length === 0) {
        navigate("/product-cart");
      }
      await setCart(JSON.parse(Cookies.get("boomer_bucks_cart")));
    }
  };

  useEffect(() => {
    if (signin) {
      cartGet();
    } else {
      withoutCart();
    }
  }, [Cookies.get("boomer_bucks_cart"), signin]);

  useEffect(() => {
    getCartQuantity();
  }, []);

  const handleNavigate = async (product_id) => {
    localStorage.setItem("product_id", product_id);
    const token = btoa(product_id.toString());
    navigate(`/vendor-page?product_id=${token}`);
  };

  const handleOpenDeliveryChange = (e) => {
    setopen_delivery(e.target.checked);
  };

  const handleQuickDeliveryChange = (e) => {
    setquick_delivery(e.target.checked);
  };

  const handleChange = (e) => {
    const instruction = e.target.value;
    setDeliveryInstruction(instruction);
  };

  const renderTooltip = (name) => (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {name}
    </Tooltip>
  );

  return (
    <>
      {cart.length > 0 ? (
        <div className="row">
          <div className="col-xxl-9 col-xl-9 col-lg-8">
            <div className="product_table">
              {signin
                ? cart?.map((value, index) => {
                    const discountRate =
                      value?.product?.membership_discount || 0;

                    const BoomerbuckzProfit =
                      (value.product_variant?.profit ||
                        value.product_multiple_variant?.profit ||
                        0) * value?.quantity;
                    boomerbuckzProfitAmount += BoomerbuckzProfit;
                    // setAdminAmount(boomerbuckzProfitAmount);

                    const basePrice =
                      (value?.product_variant?.s_price ||
                        value?.product_multiple_variant?.s_price ||
                        0) * value?.quantity;

                    const rawDiscountAmount = basePrice * discountRate;

                    const isEligibleForDiscount =
                      value?.product?.membership_type ===
                        userdata?.membership &&
                      rawDiscountAmount <= BoomerbuckzProfit;

                    const discountedPrice = isEligibleForDiscount
                      ? basePrice * (1 - discountRate)
                      : basePrice;

                    const discountAmountApplied = isEligibleForDiscount
                      ? basePrice - discountedPrice
                      : 0;

                    membershipDiscountAmount += discountAmountApplied;
                    totalPrice += discountedPrice;
                    baseAmount += basePrice;

                    shippingCharges += value?.product?.delivery_charges || 0;

                    return (
                      <div className="row tabless mb-5" key={index}>
                        <div
                          className="col-xxl-3 col-xl-3  col-lg-3 col-md-3 col-sm-3 col-4"
                          onClick={() => handleNavigate(value?.product_id)}
                        >
                          <div className="cabbageimg">
                            <img
                              src={
                                value?.product_variant?.product_images?.[0]
                                  ?.image
                                  ? IMG_URL +
                                    value.product_variant.product_images[0]
                                      .image
                                  : value?.product_multiple_variant
                                      ?.product_multi_varient_images?.[0]?.image
                                  ? IMG_URL +
                                    value.product_multiple_variant
                                      .product_multi_varient_images[0].image
                                  : "fallback-image-url" // Optional: Add a fallback image
                              }
                              className="cartimg"
                            />
                          </div>
                        </div>
                        <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9 col-8">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="prices">
                                <p className="cabbage ">
                                  {value?.product?.name}(
                                  {value?.product_variant?.v_name
                                    ? value.product_variant.v_name
                                    : value?.product_multiple_variant
                                        ?.varient_sub_name}
                                  )
                                </p>
                              </div>
                            </div>

                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 ">
                              <div className="prices">
                                <p className="prce me-2">
                                  Price :{" "}
                                  <span>
                                    ₹
                                    {value?.product_variant?.s_price
                                      ? value?.product_variant?.s_price
                                      : value?.product_multiple_variant
                                          ?.s_price}
                                  </span>
                                </p>

                                <p className="prce">
                                  Tax Percent:{" "}
                                  <span>
                                    {
                                      value?.product?.product_detail
                                        ?.tax_percentage?.name
                                    }
                                    %
                                  </span>
                                </p>
                                {/* {isEligibleForDiscount && (
                                  <p className="prce">
                                    Discounted Price :{" "}
                                    <span>₹{discountedPrice.toFixed(2)}</span>
                                  </p>
                                )} */}
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-0 "></div>

                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                              <div className="prices">
                                <p className="prce">
                                  Total Price :
                                  <span>₹{basePrice.toFixed(2)}</span>
                                </p>

                                {location.pathname == "/product-cart" && (
                                  <div className="qnty mb-3">
                                    <p className="prce mb-0">Quantity:</p>
                                    <div className="counting">
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          await getCartQuantity(
                                            value?.id,
                                            "minus",
                                          );
                                          await cartGet();
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-minus"
                                          className="minnusicns"
                                        />
                                      </button>
                                      <p className=" prce nombers">
                                        {value?.quantity}
                                      </p>
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          await getCartQuantity(
                                            value?.id,
                                            "add",
                                          );
                                          await cartGet();
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-plus"
                                          className="plusicns"
                                        />
                                      </button>
                                    </div>
                                  </div>
                                )}
                                <div>
                                  {value?.product?.cod_available === 0 ? (
                                    <p
                                      className="prce"
                                      style={{ color: "red" }}
                                    >
                                      COD Not Available
                                    </p>
                                  ) : (
                                    <p
                                      className="prce"
                                      style={{ color: "green" }}
                                    >
                                      COD Available
                                    </p>
                                  )}
                                </div>

                                {/* <div>
                                  {value?.product?.membership_type ? (
                                    <p>
                                      Product Membership :{" "}
                                      {value?.product?.membership_type}
                                    </p>
                                  ) : (
                                    <p>{""}</p>
                                  )}
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="prices delete_icon_holder">
                          <button
                            className="count-btn trash-icon_btn"
                            type="button"
                            onClick={() => handleDeleteRecord(value?.id)}
                          >
                            <FontAwesomeIcon
                              icon="fa-solid fa-trash"
                              className=" trash-icon"
                            />
                          </button>
                        </div>
                      </div>
                    );
                  })
                : cart?.map((value, index) => {
                    totalPrice += value?.price * value?.quantity;
                    const basePrice =
                      (value?.price || value?.price || 0) * value?.quantity;

                    baseAmount += Number(value.price);
                    taxPercent += Number(value.tax_percent) || 0;

                    return (
                      <div className="row tabless mb-4" key={index}>
                        <div
                          className="col-xxl-2 col-xl-2  col-lg-3 col-md-3 col-sm-3 col-4"
                          onClick={() => handleNavigate(value?.product_id)}
                        >
                          <div className="cabbageimg">
                            <img
                              src={IMG_URL + value?.image}
                              className="cartimg"
                            />
                          </div>
                        </div>
                        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-sm-9 col-8">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="prices">
                                <p className="cabbage ">
                                  {value?.product?.name}
                                </p>
                              </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 ">
                              <div className="prices">
                                <p className="prce ">
                                  Price : <span>₹{value?.price}</span>
                                </p>
                              </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 "></div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                              <div className="prices">
                                <p className="prce">
                                  Total Price :{" "}
                                  <span>₹{basePrice.toFixed(2)}</span>
                                </p>

                                {location.pathname == "/product-cart" && (
                                  <div className="qnty mb-3">
                                    <p className="prce mb-0">Quantity:</p>
                                    <div className="counting">
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          await getCartQuantity(
                                            value?.id,
                                            "minus",
                                          );
                                          await cartGet();
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-minus"
                                          className="minnusicns"
                                        />
                                      </button>
                                      <p className=" prce nombers">
                                        {value?.quantity}
                                      </p>
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          await getCartQuantity(
                                            value?.id,
                                            "add",
                                          );
                                          await cartGet();
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-plus"
                                          className="plusicns"
                                        />
                                      </button>
                                    </div>
                                  </div>
                                )}
                                <div>
                                  {value?.product?.cod_available === 0 ? (
                                    <p
                                      className="prce"
                                      style={{ color: "red" }}
                                    >
                                      COD Not Available
                                    </p>
                                  ) : (
                                    <p
                                      className="prce"
                                      style={{ color: "green" }}
                                    >
                                      COD Available
                                    </p>
                                  )}
                                </div>

                                {/* <div>
                                  {value?.product?.membership_type ? (
                                    <p>
                                      Product Membership :{" "}
                                      {value?.product?.membership_type}
                                    </p>
                                  ) : (
                                    <p>{""}</p>
                                  )}
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
            <Link to={"/"}>
              <div className="Continue_Shopping_text">
                <p>Continue Shopping</p>
              </div>
            </Link>

            {signin && (
              <>
                {" "}
                <div className="mb-2">
                  <strong>Membership Price Flow</strong>
                </div>
                <div classNames="mt-2" style={{ position: "relative" }}>
                  <ProgressBar style={{ height: "50px" }}>
                    {/* Segment 1: 0 to 3000 */}
                    <ProgressBar
                      now={Math.min(investCount?.amount, 3000)}
                      max={10000} // Keep max as 10000 to ensure the total progress bar is consistent
                      label={
                        investCount?.amount <= 3000
                          ? `${investCount?.amount} ₹`
                          : null
                      }
                      variant="danger"
                      key={1}
                    />

                    {/* Segment 2: 3000 to 6000 */}
                    {investCount?.amount > 3000 && (
                      <ProgressBar
                        now={Math.min(investCount?.amount - 3000, 3000)}
                        max={10000}
                        label={
                          investCount?.amount <= 6000
                            ? `${investCount?.amount} ₹`
                            : null
                        }
                        variant="info"
                        key={2}
                      />
                    )}

                    {/* Segment 3: 6000 to 10000 */}
                    {investCount?.amount > 6000 && (
                      <ProgressBar
                        now={Math.min(investCount?.amount - 6000, 4000)}
                        max={10000}
                        label={
                          investCount?.amount <= 10000
                            ? `${investCount?.amount} ₹`
                            : null
                        }
                        variant="warning "
                        key={3}
                      />
                    )}

                    {/* Additional segment if amount exceeds 10000 */}
                    {investCount?.amount > 10000 && (
                      <ProgressBar
                        now={investCount?.amount - 10000}
                        max={investCount?.amount} // Use dynamic max if amount exceeds 10000
                        label={`${investCount?.amount} ₹`}
                        variant="success"
                        key={4}
                      />
                    )}
                  </ProgressBar>
                </div>
                <br></br>
                <div className="d-flex mb-3">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip(
                      "Spend 3000 To get Silver Membership",
                    )}
                  >
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="info-icon"
                    />
                  </OverlayTrigger>
                  <div className="blue_round ms-2"></div>
                  <div className="colour_text">Silver</div>
                </div>
                <div className="d-flex  mb-3">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Spend 6000 To get Gold Membership")}
                  >
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="info-icon"
                    />
                  </OverlayTrigger>
                  <div className="Yellow_round ms-2"></div>
                  <div className="colour_text">Gold</div>
                </div>
                <div className="d-flex  mb-1">
                  <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip(
                      "Spend 10000 To get Platinum Membership",
                    )}
                  >
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="info-icon"
                    />
                  </OverlayTrigger>
                  <div className="green_round ms-2"></div>
                  <div className="colour_text">Platinum</div>
                </div>
              </>
            )}

            {/* <div className="d-flex  mb-1">
              <div>Above 10000</div>
              <div className="blue_round ms-2"></div>
            </div> */}
          </div>

          <div className="col-xxl-3 col-xl-3 col-lg-4">
            <div className="grand_total_table">
              <div className="orderss">
                <h6 className="ordersum">Order Summary</h6>
              </div>
              <Table responsive>
                <thead>
                  <tr className="top-border">
                    <th>Sub Total amount</th>
                    <td>₹{Number(baseAmount).toFixed(2)}</td>
                  </tr>
                </thead>

                <thead>
                  <tr className="top-border">
                    <th>Tax Included</th>
                    <td>
                      ₹
                      {signin
                        ? cart
                            .reduce((acc, item) => {
                              const price =
                                item?.product_variant?.s_price ||
                                item?.product_multiple_variant?.s_price ||
                                0;

                              const qty = item?.quantity || 1;

                              const totalWithTax =
                                (price * qty) /
                                (1 +
                                  Number(
                                    item.product?.product_detail?.tax_percentage
                                      ?.name,
                                  ) /
                                    100);

                              console.log(totalWithTax, "totalWithTax");

                              const itemTax = price * qty - totalWithTax;

                              console.log(itemTax, "itemTax");

                              return acc + itemTax;
                            }, 0)
                            .toFixed(2)
                        : ((baseAmount * taxPercent) / 100).toFixed(2)}
                    </td>
                  </tr>
                </thead>

                {userdata?.membership && membershipDiscountAmount !== 0 && (
                  <thead>
                    <tr className="top-border">
                      <th>
                        Extra Discount Applied ({userdata.membership}{" "}
                        Membership)
                      </th>
                      <td>
                        ₹
                        {(() => {
                          // Initialize discountAmount to 0
                          let discountAmount = 0;

                          // Loop through the cart to calculate the discount only for eligible products
                          cart.forEach((value) => {
                            const discountRate =
                              value?.product?.membership_discount || 0;

                            const isEligibleForDiscount =
                              value?.product?.membership_type ===
                              userdata?.membership;

                            if (isEligibleForDiscount) {
                              const productPrice = value?.product_variant
                                ?.s_price
                                ? value.product_variant.s_price
                                : value?.product_multiple_variant?.s_price;

                              discountAmount +=
                                Number(productPrice) *
                                Number(discountRate) *
                                value?.quantity;
                            }
                          });

                          // Optionally, update the membership discount in the context
                          setMembershipDiscount(discountAmount);

                          return discountAmount.toFixed(2); // Return the formatted discount amount
                        })()}
                      </td>
                    </tr>
                  </thead>
                )}

                {couponStatus && (
                  <thead>
                    <tr>
                      <th>Coupon Discount</th>
                      <td>₹{discount}</td>
                    </tr>
                  </thead>
                )}

                {/* <thead>
                  <tr className="top-border">
                    <th>Tax</th>
                    <td>₹{totalTax.toFixed(2)}</td>
                  </tr>
                </thead> */}

                <thead>
                  <tr className="top-border">
                    <th>Shipping Charges</th>
                    <td>₹{shippingCharges.toFixed(2)}</td>
                  </tr>
                </thead>

                {userdata?.membership === null &&
                  type === "checkout" &&
                  cart.length === 1 && (
                    <thead>
                      {/* <tr className="Coupon_code_holder top-border">
                        <td className="Coupon_code" colSpan={2}>
                          <Form>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              type="text"
                              name="code"
                              placeholder="Enter Code"
                              value={copyCode}
                              {...register("code", {
                                required: "Code is required",
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.code,
                                "is-valid": getValues("code"),
                              })}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                setCopyCode(inputValue);
                                setDiscount(0);
                                setCoupon("");
                                setCouponStatus(false);
                                setError("code", "");
                              }}
                            />
                            <span style={{ color: "red" }}>{cardError}</span>
                          </Form>
                        </td>
                      </tr> */}

                      {/* <tr>
                        <td colSpan={2}>
                          <button
                            className="Checkout_btn show-coupon-btn-holder"
                            type="button"
                            onClick={handleOpenModal}
                          >
                            Show Coupons
                          </button>
                          <CoupanModal
                            setCopyCode={setCopyCode}
                            show={showModal}
                            handleClose={handleCloseModal}
                          />
                        </td>
                      </tr> */}

                      <tr>
                        <td colSpan={2}>
                          <sup
                            className="text-danger"
                            style={{ fontSize: "1.2em" }}
                          >
                            {couponErrors
                              ? couponErrors
                              : errors?.code?.message}
                          </sup>
                        </td>
                      </tr>
                    </thead>
                  )}

                <CouponModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                  message={`Item Deleted From Cart`}
                />

                <CouponModal
                  show={modalShowCoupon}
                  onHide={() => setModalShowCoupon(false)}
                  message={`Coupon Applied Successfully`}
                />

                <thead>
                  <tr className="bottom-border">
                    <th className="bold-text">Total</th>
                    <td className="bold-text">
                      ₹
                      <span>
                        {(() => {
                          const subtotal =
                            Number(totalPrice) + Number(shippingCharges);
                          setDeliveryCharges(shippingCharges);
                          const discounts = userdata?.membership
                            ? Number((totalPrice * discountRate).toFixed(2))
                            : discount;

                          totalAmount = Math.round(
                            subtotal - discount + (quick_delivery ? 35 : 0),
                          ).toFixed(2);

                          setAmount(totalAmount);

                          return totalAmount;
                        })()}
                      </span>
                    </td>
                  </tr>
                </thead>

                {cart.length == 1 && (
                  <tr className="Coupon_code_holder top-border">
                    <td colSpan={2}>
                      <div className="button-holder">
                        {couponStatus ? (
                          <Button
                            className="Checkout_btn"
                            type="button"
                            onClick={() => {
                              setDiscount(0);
                              setCoupon("");
                              setCopyCode("");
                              setCouponStatus(false);
                              reset();
                            }}
                          >
                            Remove Coupon
                          </Button>
                        ) : (
                          <>
                            {userdata?.membership ||
                            location.pathname == "/product-cart" ? (
                              ""
                            ) : (
                              <Button
                                className="Checkout_btn"
                                type="button"
                                onClick={handleOpenModal}
                              >
                                Apply Coupon
                              </Button>
                            )}
                            <CoupanModal
                              setCopyCode={setCopyCode}
                              show={showModal}
                              setError={setError}
                              getCouponCode={getCouponCode}
                              varient_amount={varient_amount}
                              handleClose={handleCloseModal}
                              product_id={product_id}
                              setCardError={setCardError}
                              setCouponStatus={setCouponStatus}
                              setDiscount={setDiscount}
                              discount={discount}
                              setCouponError={setCouponError}
                              setMessage={setMessage}
                              message={message}
                              setModalShowCoupon={setModalShowCoupon}
                              setCoupon={setCoupon}
                              coupon={coupon}
                              totalPrice={totalPrice}
                              shippingCharges={shippingCharges}
                              totalAmount={totalAmount}
                              couponErrors={couponErrors}
                              variant_id={cart?.[0]?.variant_id}
                              m_variant_id={cart?.[0]?.m_variant_id}
                            />
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </Table>

              <div className="check-box-text-holder">
                <Form className="">
                  {location.pathname == "/product-cart-details" && (
                    <div className="check-box-holder-info">
                      <Form.Check
                        label="Quick Delivery"
                        name="Quick_Delivery"
                        type="checkbox"
                        className="me-1 my-2"
                        checked={quick_delivery}
                        onChange={handleQuickDeliveryChange}
                      />

                      <OverlayTrigger
                        overlay={
                          <Tooltip id="tooltip-quick-delivery">
                            Quick Delivery ₹35
                          </Tooltip>
                        }
                        placement="left"
                      >
                        <FontAwesomeIcon
                          icon={faCircleInfo}
                          className="info-icon"
                        />
                      </OverlayTrigger>
                    </div>
                  )}

                  <div className="check-box-holder-info">
                    <Form.Check
                      type="checkbox"
                      label="Open Delivery"
                      checked={open_delivery}
                      onChange={handleOpenDeliveryChange}
                    />
                    <OverlayTrigger
                      overlay={
                        <Tooltip id="tooltip-open-delivery">
                          Open Delivery
                        </Tooltip>
                      }
                      placement="left"
                    >
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="info-icon"
                      />
                    </OverlayTrigger>
                  </div>
                </Form>
              </div>
            </div>
            <p className="text-danger">
              {userdata?.membership &&
                `Note : You are in ${userdata?.membership} Membership no Coupon Applicable`}
            </p>

            {location.pathname == "/product-cart-details" && (
              <div className="instruction-field-holder mt-4">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>
                    <b>Add Delivery Instruction</b>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    onChange={handleChange}
                  />
                </Form.Group>
              </div>
            )}
            {/* <h3>{outOfStock}</h3> */}

            <div className="row justify-content-end mb-3">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-6">
                <div className="button-holder text-end">
                  {/* {signin && */}
                  {showButton && (
                    <Link to={signin ? "/product-cart-details" : "/login"}>
                      <Button className="procheckout_btn" type="button">
                        Proceed to Checkout
                      </Button>
                    </Link>
                  )}
                  {/* } */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <section className="Empty_Cart">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-3 col-lg-5 col-md-6 col-sm-7 col-10">
                <div className="shop-now-content">
                  <div className="img-holder">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Cash_On_Delivery_Process/basket.png"
                      }
                      className="basket_img"
                    />
                  </div>
                  <div className="heading_holder mt-3">
                    <h5>Your cart is Empty</h5>
                    <p>
                      You have no items in your shopping cart. Let's go buy
                      something
                    </p>
                    <div className="main-btn-div">
                      <Link to={"/"}>
                        <button className="back-btn" type="button">
                          Shop Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* <CoupanModal
                show={showModal}
                handleClose={handleCloseModal}
            /> */}
    </>
  );
};

export default Cart;
